import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

const STATUS_OPTS = ['pending', 'approved', 'rejected'];

const Inp = ({ label, value, onChange, type = 'text', required = false }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>
      {label} {required && <span style={{ color: '#0e76bc' }}>*</span>}
    </label>
    {type === 'textarea' ? (
      <textarea value={value} onChange={e => onChange(e.target.value)} rows={3}
        style={{ width: '100%', padding: '8px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, fontFamily: 'inherit', resize: 'vertical', boxSizing: 'border-box' }} />
    ) : (
      <input type={type} value={value} onChange={e => onChange(e.target.value)}
        style={{ width: '100%', padding: '8px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box' }} />
    )}
  </div>
);

const Sel = ({ label, value, onChange, options }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>{label}</label>
    <select value={value} onChange={e => onChange(e.target.value)}
      style={{ width: '100%', padding: '8px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, background: '#fff', fontFamily: 'inherit' }}>
      {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  </div>
);

function TabBtn({ label, active, onClick }) {
  return (
    <button onClick={onClick} style={{
      padding: '8px 16px', border: 'none',
      borderBottom: active ? '2px solid #0e76bc' : '2px solid transparent',
      background: 'none', color: active ? '#0e76bc' : '#6b7280',
      fontWeight: active ? 700 : 500, fontSize: 14, cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap',
    }}>{label}</button>
  );
}

const BtnPrimary = ({ children, onClick, disabled }) => (
  <button onClick={onClick} disabled={disabled} style={{
    background: disabled ? '#9ca3af' : 'linear-gradient(135deg, #0e76bc, #0b5e96)',
    color: '#fff', border: 'none', borderRadius: 7, padding: '8px 16px',
    fontSize: 13, fontWeight: 700, cursor: disabled ? 'not-allowed' : 'pointer', fontFamily: 'inherit',
  }}>{children}</button>
);

const BtnSecondary = ({ children, onClick }) => (
  <button onClick={onClick} style={{
    background: '#fff', color: '#374151', border: '1px solid #e5e7eb',
    borderRadius: 7, padding: '8px 14px', fontSize: 13, cursor: 'pointer', fontFamily: 'inherit',
  }}>{children}</button>
);

const BtnDanger = ({ children, onClick }) => (
  <button onClick={onClick} style={{
    background: 'none', color: '#dc2626', border: '1px solid #b3d9f2',
    borderRadius: 7, padding: '5px 12px', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit',
  }}>{children}</button>
);

const Grid2 = ({ children }) => <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>{children}</div>;
const Grid3 = ({ children }) => <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0 16px' }}>{children}</div>;

function NewsTab({ apiFetch }) {
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const empty = { title_cs: '', title_sk: '', title_ro: '', title_en: '', title_hu: '', body_cs: '', body_sk: '', body_ro: '', body_en: '', body_hu: '', image_url: '', is_published: 1 };
  const [form, setForm] = useState(empty);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const load = () => apiFetch('/news').then(setItems);
  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    try {
      if (editing) await apiFetch(`/news/${editing}`, { method: 'PUT', body: JSON.stringify(form) });
      else await apiFetch('/news', { method: 'POST', body: JSON.stringify(form) });
      setShowForm(false); setEditing(null); setForm(empty); load();
    } catch (e) { alert(e.message); }
  };

  const handleEdit = (item) => {
    setForm({ title_cs: item.title_cs||'', title_sk: item.title_sk||'', title_ro: item.title_ro||'',
      body_cs: item.body_cs||'', body_sk: item.body_sk||'', body_ro: item.body_ro||'',
      image_url: item.image_url||'', is_published: item.is_published });
    setEditing(item.id); setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Opravdu smazat tuto novinku?')) return;
    await apiFetch(`/news/${id}`, { method: 'DELETE' }); load();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <span style={{ fontWeight: 700, fontSize: 15, color: '#374151' }}>{items.length} novinek</span>
        <BtnPrimary onClick={() => { setForm(empty); setEditing(null); setShowForm(!showForm); }}>
          {showForm ? 'Zavrit' : '+ Pridat novinku'}
        </BtnPrimary>
      </div>
      {showForm && (
        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 10, padding: 20, marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 15, fontWeight: 700 }}>{editing ? 'Upravit novinku' : 'Nova novinka'}</h3>
          <Grid3>
            <Inp label="Nazev (CS)" value={form.title_cs} onChange={v => set('title_cs', v)} required />
            <Inp label="Nazev (SK)" value={form.title_sk} onChange={v => set('title_sk', v)} />
            <Inp label="Nazev (RO)" value={form.title_ro} onChange={v => set('title_ro', v)} />
            <Inp label="Nazev (EN)" value={form.title_en||''} onChange={v => set('title_en', v)} />
            <Inp label="Nazev (HU)" value={form.title_hu||''} onChange={v => set('title_hu', v)} />
          </Grid3>
          <Grid3>
            <Inp label="Text (CS)" value={form.body_cs} onChange={v => set('body_cs', v)} type="textarea" required />
            <Inp label="Text (SK)" value={form.body_sk} onChange={v => set('body_sk', v)} type="textarea" />
            <Inp label="Text (RO)" value={form.body_ro} onChange={v => set('body_ro', v)} type="textarea" />
            <Inp label="Text (EN)" value={form.body_en||''} onChange={v => set('body_en', v)} type="textarea" />
            <Inp label="Text (HU)" value={form.body_hu||''} onChange={v => set('body_hu', v)} type="textarea" />
          </Grid3>
          <Grid2>
            <Inp label="URL obrazku" value={form.image_url} onChange={v => set('image_url', v)} />
            <Sel label="Stav" value={form.is_published} onChange={v => set('is_published', Number(v))}
              options={[{ value: 1, label: 'Zverejneno' }, { value: 0, label: 'Skryta' }]} />
          </Grid2>
          <div style={{ display: 'flex', gap: 10 }}>
            <BtnPrimary onClick={handleSave} disabled={!form.title_cs || !form.body_cs}>Ulozit</BtnPrimary>
            <BtnSecondary onClick={() => { setShowForm(false); setEditing(null); }}>Zrusit</BtnSecondary>
          </div>
        </div>
      )}
      <div style={{ display: 'grid', gap: 10 }}>
        {items.map(item => (
          <div key={item.id} style={{ background: '#fff', borderRadius: 10, padding: '14px 18px', border: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#111827' }}>{item.title_cs}</div>
              <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}>
                {new Date(item.published_at).toLocaleDateString('cs-CZ')} · {item.is_published ? 'Zverejneno' : 'Skryta'}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <BtnSecondary onClick={() => handleEdit(item)}>Upravit</BtnSecondary>
              <BtnDanger onClick={() => handleDelete(item.id)}>Smazat</BtnDanger>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function TrainingsTab({ apiFetch }) {
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [attendees, setAttendees] = useState(null);
  const [attendeesTitle, setAttendeesTitle] = useState('');
  const [subdistributors, setSubdistributors] = useState([]);
  const empty = { title_cs: '', title_sk: '', title_ro: '', title_en: '', title_hu: '', description_cs: '', description_sk: '', description_ro: '', description_en: '', description_hu: '', trainer: '', location: '', is_online: 0, date_from: '', date_to: '', capacity: 20, lang: 'cs', organizer_id: '', country: 'CZ' };
  const [form, setForm] = useState(empty);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const [editing, setEditing] = useState(null);
  const load = () => Promise.all([
    apiFetch('/trainings'),
    apiFetch('/subdistributors'),
  ]).then(([tr, subdist]) => { setItems(tr); setSubdistributors(subdist); });
  useEffect(() => { load(); }, []);

  const startEdit = (item) => {
    setForm({
      title_cs: item.title_cs, title_sk: item.title_sk||'', title_ro: item.title_ro||'',
      title_en: item.title_en||'', title_hu: item.title_hu||'',
      description_cs: item.description_cs||'', description_sk: item.description_sk||'',
      description_ro: item.description_ro||'', description_en: item.description_en||'',
      description_hu: item.description_hu||'',
      trainer: item.trainer||'', location: item.location||'',
      is_online: item.is_online||0, date_from: item.date_from||'', date_to: item.date_to||'',
      capacity: item.capacity||20, lang: item.lang||'cs',
      organizer_id: item.organizer_id||'', country: item.country||'CZ',
    });
    setEditing(item.id);
    setShowForm(false);
    window.scrollTo(0, 0);
  };

  const handleUpdate = async () => {
    try {
      await apiFetch(`/trainings/${editing}`, { method: 'PUT', body: JSON.stringify(form) });
      setEditing(null); setForm(empty); load();
    } catch(e) { alert(e.message); }
  };

  const showAttendees = async (item) => {
    const data = await apiFetch(`/admin/trainings/${item.id}/registrations`);
    setAttendees(data);
    setAttendeesTitle(item.title_cs);
  };

  const handleSave = async () => {
    try {
      await apiFetch('/trainings', { method: 'POST', body: JSON.stringify(form) });
      setShowForm(false); setForm(empty); load();
    } catch (e) { alert(e.message); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Opravdu smazat toto skoleni?')) return;
    await apiFetch(`/trainings/${id}`, { method: 'DELETE' }); load();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <span style={{ fontWeight: 700, fontSize: 15, color: '#374151' }}>{items.length} skoleni</span>
        <BtnPrimary onClick={() => { setForm(empty); setEditing(null); setShowForm(!showForm); }}>
          {showForm ? 'Zavrit' : '+ Pridat skoleni'}
        </BtnPrimary>
      </div>
      {(showForm || editing) && (
        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 10, padding: 20, marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 15, fontWeight: 700 }}>{editing ? 'Upravit skoleni' : 'Nove skoleni'}</h3>
          <Grid3>
            <Inp label="Nazev (CS)" value={form.title_cs} onChange={v => set('title_cs', v)} required />
            <Inp label="Nazev (SK)" value={form.title_sk} onChange={v => set('title_sk', v)} />
            <Inp label="Nazev (RO)" value={form.title_ro} onChange={v => set('title_ro', v)} />
            <Inp label="Nazev (EN)" value={form.title_en||''} onChange={v => set('title_en', v)} />
            <Inp label="Nazev (HU)" value={form.title_hu||''} onChange={v => set('title_hu', v)} />
          </Grid3>
          <Grid3>
            <Inp label="Popis (CS)" value={form.description_cs} onChange={v => set('description_cs', v)} type="textarea" />
            <Inp label="Popis (SK)" value={form.description_sk} onChange={v => set('description_sk', v)} type="textarea" />
            <Inp label="Popis (RO)" value={form.description_ro} onChange={v => set('description_ro', v)} type="textarea" />
            <Inp label="Popis (EN)" value={form.description_en||''} onChange={v => set('description_en', v)} type="textarea" />
            <Inp label="Popis (HU)" value={form.description_hu||''} onChange={v => set('description_hu', v)} type="textarea" />
          </Grid3>
          <Grid2>
            <Inp label="Lektor" value={form.trainer} onChange={v => set('trainer', v)} />
            <Inp label="Misto / URL" value={form.location} onChange={v => set('location', v)} />
            <Inp label="Datum od" value={form.date_from} onChange={v => set('date_from', v)} type="datetime-local" required />
            <Inp label="Datum do" value={form.date_to} onChange={v => set('date_to', v)} type="datetime-local" />
            <Inp label="Kapacita" value={form.capacity} onChange={v => set('capacity', Number(v))} type="number" />
            <Sel label="Typ" value={form.is_online} onChange={v => set('is_online', Number(v))}
              options={[{ value: 0, label: 'Prezencne' }, { value: 1, label: 'Online' }]} />
            <Sel label="Jazyk skoleni" value={form.lang} onChange={v => set('lang', v)}
              options={[{ value: 'cs', label: '🇨🇿 Čeština' }, { value: 'sk', label: '🇸🇰 Slovenčina' }, { value: 'ro', label: '🇷🇴 Română' }, { value: 'en', label: '🇬🇧 English' }, { value: 'hu', label: '🇭🇺 Magyar' }]} />
            {form.is_online === 0 && (
              <Sel label="Stat konani" value={form.country||'CZ'} onChange={v => set('country', v)}
                options={[{ value: 'CZ', label: 'Česká republika' }, { value: 'SK', label: 'Slovensko' }, { value: 'RO', label: 'Rumunsko' }, { value: 'HU', label: 'Maďarsko' }, { value: 'PL', label: 'Polsko' }, { value: 'DE', label: 'Německo' }, { value: 'AT', label: 'Rakousko' }, { value: 'OTHER', label: 'Jiný' }]} />
            )}
          </Grid2>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Pořádající firma</label>
            <select value={form.organizer_id||''} onChange={e => set('organizer_id', e.target.value ? Number(e.target.value) : '')}
              style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', background: '#fff', boxSizing: 'border-box' }}>
              <option value="">— Nezadáno —</option>
              {subdistributors.map(s => <option key={s.id} value={s.id}>{s.name} ({s.country})</option>)}
            </select>
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <BtnPrimary onClick={editing ? handleUpdate : handleSave} disabled={!form.title_cs || !form.date_from}>Ulozit</BtnPrimary>
            <BtnSecondary onClick={() => { setShowForm(false); setEditing(null); setForm(empty); }}>Zrusit</BtnSecondary>
          </div>
        </div>
      )}
      <div style={{ display: 'grid', gap: 10 }}>
        {items.map(item => (
          <div key={item.id} style={{ background: '#fff', borderRadius: 10, padding: '14px 18px', border: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#111827' }}>{item.title_cs}</div>
              <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}>
                {new Date(item.date_from).toLocaleDateString('cs-CZ')} · {item.location} · {item.trainer} · {item.registered_count}/{item.capacity}
                {item.organizer_name && <span style={{ color: '#0e76bc', fontWeight: 600 }}> · {item.organizer_name}</span>}
                {' · '}<span style={{ background: '#f3f4f6', padding: '1px 6px', borderRadius: 4 }}>{(item.lang||'cs').toUpperCase()}</span>
                {!item.is_online && item.country && item.country !== 'CZ' && <span> · 🌍 {item.country}</span>}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <BtnSecondary onClick={() => showAttendees(item)}>Ucastnici ({item.registered_count})</BtnSecondary>
              <BtnSecondary onClick={() => startEdit(item)}>Upravit</BtnSecondary>
              <BtnDanger onClick={() => handleDelete(item.id)}>Smazat</BtnDanger>
            </div>
          </div>
        ))}
      </div>

      {attendees !== null && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 28, maxWidth: 600, width: '90%', maxHeight: '80vh', overflow: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800 }}>Ucastnici: {attendeesTitle}</h3>
              <BtnSecondary onClick={() => setAttendees(null)}>Zavrit</BtnSecondary>
            </div>
            {attendees.length === 0 ? (
              <p style={{ color: '#9ca3af', textAlign: 'center', padding: 20 }}>Zadni prihlaseni ucastnici.</p>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #f3f4f6', textAlign: 'left' }}>
                    <th style={{ padding: '8px 12px', color: '#6b7280', fontWeight: 600 }}>Jmeno</th>
                    <th style={{ padding: '8px 12px', color: '#6b7280', fontWeight: 600 }}>E-mail</th>
                    <th style={{ padding: '8px 12px', color: '#6b7280', fontWeight: 600 }}>Firma</th>
                    <th style={{ padding: '8px 12px', color: '#6b7280', fontWeight: 600 }}>Typ</th>
                    <th style={{ padding: '8px 12px', color: '#6b7280', fontWeight: 600 }}>Datum</th>
                  </tr>
                </thead>
                <tbody>
                  {attendees.map((a, i) => (
                    <tr key={i} style={{ borderBottom: '1px solid #f9fafb' }}>
                      <td style={{ padding: '10px 12px', fontWeight: 600 }}>{a.name}</td>
                      <td style={{ padding: '10px 12px', color: '#0e76bc' }}><a href={`mailto:${a.email}`} style={{ color: 'inherit' }}>{a.email}</a></td>
                      <td style={{ padding: '10px 12px', color: '#6b7280' }}>{a.company_name}</td>
                      <td style={{ padding: '10px 12px', fontSize: 12 }}>
                        {a.type === 'Host' ? (
                          <span style={{ background: '#f0f9ff', color: '#0369a1', fontWeight: 600, padding: '2px 8px', borderRadius: 10 }}>
                            Host {a.registered_by ? `(přes: ${a.registered_by})` : ''}
                          </span>
                        ) : (
                          <span style={{ background: '#f0fdf4', color: '#166534', fontWeight: 600, padding: '2px 8px', borderRadius: 10 }}>Vlastní</span>
                        )}
                      </td>
                      <td style={{ padding: '10px 12px', color: '#9ca3af', fontSize: 12 }}>{new Date(a.registered_at).toLocaleDateString('cs-CZ')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function ExhibitionsTab({ apiFetch }) {
  const [items, setItems] = useState([]);
  const [subdistributors, setSubdistributors] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const empty = { title_cs: '', title_sk: '', title_ro: '', title_en: '', title_hu: '', description_cs: '', location: '', country: 'CZ', date_from: '', date_to: '', website_url: '', booth: '', organizer_id: '' };
  const [form, setForm] = useState(empty);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const [editing, setEditing] = useState(null);
  const load = () => Promise.all([
    apiFetch('/exhibitions'),
    apiFetch('/subdistributors'),
  ]).then(([exh, subdist]) => { setItems(exh); setSubdistributors(subdist); });
  useEffect(() => { load(); }, []);

  const startEdit = (item) => {
    setForm({
      title_cs: item.title_cs, title_sk: item.title_sk||'', title_ro: item.title_ro||'',
      title_en: item.title_en||'', title_hu: item.title_hu||'',
      description_cs: item.description_cs||'', location: item.location||'',
      country: item.country||'CZ', date_from: item.date_from||'', date_to: item.date_to||'',
      website_url: item.website_url||'', booth: item.booth||'',
      organizer_id: item.organizer_id||'', is_published: item.is_published??1,
    });
    setEditing(item.id);
    setShowForm(false);
    window.scrollTo(0, 0);
  };

  const handleSave = async () => {
    try {
      await apiFetch('/exhibitions', { method: 'POST', body: JSON.stringify(form) });
      setShowForm(false); setForm(empty); load();
    } catch (e) { alert(e.message); }
  };

  const handleUpdate = async () => {
    try {
      await apiFetch(`/exhibitions/${editing}`, { method: 'PUT', body: JSON.stringify(form) });
      setEditing(null); setForm(empty); load();
    } catch(e) { alert(e.message); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Opravdu smazat tuto vystavu?')) return;
    await apiFetch(`/exhibitions/${id}`, { method: 'DELETE' }); load();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <span style={{ fontWeight: 700, fontSize: 15, color: '#374151' }}>{items.length} vystav</span>
        <BtnPrimary onClick={() => { setForm(empty); setShowForm(!showForm); }}>
          {showForm ? 'Zavrit' : '+ Pridat vystavu'}
        </BtnPrimary>
      </div>
      {(showForm || editing) && (
        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 10, padding: 20, marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 15, fontWeight: 700 }}>{editing ? 'Upravit vystavu' : 'Nova vystava'}</h3>
          <Grid3>
            <Inp label="Nazev (CS)" value={form.title_cs} onChange={v => set('title_cs', v)} required />
            <Inp label="Nazev (SK)" value={form.title_sk} onChange={v => set('title_sk', v)} />
            <Inp label="Nazev (RO)" value={form.title_ro} onChange={v => set('title_ro', v)} />
            <Inp label="Nazev (EN)" value={form.title_en||''} onChange={v => set('title_en', v)} />
            <Inp label="Nazev (HU)" value={form.title_hu||''} onChange={v => set('title_hu', v)} />
          </Grid3>
          <Grid2>
            <Inp label="Misto konani" value={form.location} onChange={v => set('location', v)} required />
            <Sel label="Zeme" value={form.country} onChange={v => set('country', v)} options={[
              { value: 'CZ', label: 'Ceska republika' }, { value: 'SK', label: 'Slovensko' },
              { value: 'RO', label: 'Rumunsko' }, { value: 'DE', label: 'Nemecko' }, { value: 'AT', label: 'Rakousko' },
            ]} />
            <Inp label="Datum od" value={form.date_from} onChange={v => set('date_from', v)} type="datetime-local" required />
            <Inp label="Datum do" value={form.date_to} onChange={v => set('date_to', v)} type="datetime-local" />
            <Inp label="Web vystavy" value={form.website_url} onChange={v => set('website_url', v)} />
            <Inp label="Stanek / hala" value={form.booth} onChange={v => set('booth', v)} />
          </Grid2>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Pořádající firma</label>
            <select value={form.organizer_id||''} onChange={e => set('organizer_id', e.target.value ? Number(e.target.value) : '')}
              style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', background: '#fff', boxSizing: 'border-box' }}>
              <option value="">— Nezadáno —</option>
              {subdistributors.map(s => <option key={s.id} value={s.id}>{s.name} ({s.country})</option>)}
            </select>
          </div>
          <Inp label="Popis (CS)" value={form.description_cs} onChange={v => set('description_cs', v)} type="textarea" />
          <div style={{ display: 'flex', gap: 10 }}>
            <BtnPrimary onClick={editing ? handleUpdate : handleSave} disabled={!form.title_cs || !form.location || !form.date_from}>Ulozit</BtnPrimary>
            <BtnSecondary onClick={() => { setShowForm(false); setEditing(null); setForm(empty); }}>Zrusit</BtnSecondary>
          </div>
        </div>
      )}
      <div style={{ display: 'grid', gap: 10 }}>
        {items.map(item => (
          <div key={item.id} style={{ background: '#fff', borderRadius: 10, padding: '14px 18px', border: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#111827' }}>{item.title_cs}</div>
              <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}>
                {new Date(item.date_from).toLocaleDateString('cs-CZ')} · {item.location}
                {item.booth && ` · ${item.booth}`}
                {item.organizer_name && <span style={{ color: '#0e76bc', fontWeight: 600 }}> · {item.organizer_name}</span>}
              </div>
            </div>
            <BtnSecondary onClick={() => startEdit(item)}>Upravit</BtnSecondary>
            <BtnDanger onClick={() => handleDelete(item.id)}>Smazat</BtnDanger>
          </div>
        ))}
      </div>
    </div>
  );
}

function ProjectsAdminTab({ t, apiFetch }) {
  const [projects, setProjects] = useState([]);
  const [editing, setEditing] = useState(null);
  const [filters, setFilters] = useState({ project_name: '', end_customer: '', end_customer_ico: '', date_from: '', date_to: '', realization_from: '', realization_to: '' });
  const setF = (k, v) => setFilters(f => ({ ...f, [k]: v }));
  const [showFilters, setShowFilters] = useState(false);

  const load = () => apiFetch('/admin/projects').then(setProjects);
  useEffect(() => { load(); }, []);
  const updateProject = async (id, data) => {
    await apiFetch(`/admin/projects/${id}`, { method: 'PUT', body: JSON.stringify(data) });
    setEditing(null); load();
  };
  const STATUS_COLOR = { pending: '#92400e', approved: '#166534', rejected: '#991b1b' };
  const STATUS_BG = { pending: '#fffbeb', approved: '#f0fdf4', rejected: '#e8f4fc' };

  const filtered = projects.filter(p => {
    if (filters.project_name && !p.project_name.toLowerCase().includes(filters.project_name.toLowerCase())) return false;
    if (filters.end_customer && !p.end_customer.toLowerCase().includes(filters.end_customer.toLowerCase())) return false;
    if (filters.end_customer_ico && !(p.end_customer_ico||'').toLowerCase().includes(filters.end_customer_ico.toLowerCase())) return false;
    if (filters.date_from && new Date(p.created_at) < new Date(filters.date_from)) return false;
    if (filters.date_to && new Date(p.created_at) > new Date(filters.date_to + 'T23:59:59')) return false;
    if (filters.realization_from && p.realization_date && p.realization_date < filters.realization_from) return false;
    if (filters.realization_to && p.realization_date && p.realization_date > filters.realization_to) return false;
    return true;
  });

  const activeFilters = Object.values(filters).filter(Boolean).length;
  const clearFilters = () => setFilters({ project_name: '', end_customer: '', end_customer_ico: '', date_from: '', date_to: '', realization_from: '', realization_to: '' });

  const fInp = (label, key, type='text') => (
    <div>
      <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#6b7280', marginBottom: 4 }}>{label}</label>
      <input type={type} value={filters[key]} onChange={e => setF(key, e.target.value)}
        style={{ width: '100%', padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box', background: filters[key] ? '#e8f4fc' : '#fff' }} />
    </div>
  );

  return (
    <div>
      {/* Filter bar */}
      <div style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: showFilters ? 12 : 0 }}>
          <span style={{ fontWeight: 700, fontSize: 15, color: '#374151' }}>
            {filtered.length} / {projects.length} projektu
            {activeFilters > 0 && <span style={{ marginLeft: 8, background: '#e8f4fc', color: '#0e76bc', fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 10 }}>{activeFilters} filtr</span>}
          </span>
          <div style={{ display: 'flex', gap: 8 }}>
            {activeFilters > 0 && <BtnSecondary onClick={clearFilters}>Zrusit filtry</BtnSecondary>}
            <BtnSecondary onClick={() => setShowFilters(!showFilters)}>{showFilters ? '▲ Skryt filtry' : '▼ Filtrovat'}</BtnSecondary>
          </div>
        </div>
        {showFilters && (
          <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 10, padding: 16 }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12 }}>
              {fInp('Název projektu', 'project_name')}
              {fInp('Koncový zákazník', 'end_customer')}
              {fInp('IČ zákazníka', 'end_customer_ico')}
              {fInp('Zadáno od', 'date_from', 'date')}
              {fInp('Zadáno do', 'date_to', 'date')}
              <div>
                <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#6b7280', marginBottom: 4 }}>Realizace od</label>
                <input type="month" value={filters.realization_from} onChange={e => setF('realization_from', e.target.value)}
                  style={{ width: '100%', padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box', background: filters.realization_from ? '#e8f4fc' : '#fff' }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#6b7280', marginBottom: 4 }}>Realizace do</label>
                <input type="month" value={filters.realization_to} onChange={e => setF('realization_to', e.target.value)}
                  style={{ width: '100%', padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box', background: filters.realization_to ? '#e8f4fc' : '#fff' }} />
              </div>
            </div>
          </div>
        )}
      </div>

      <div style={{ display: 'grid', gap: 12 }}>
      {filtered.length === 0 && <div style={{ textAlign: 'center', padding: 40, color: '#9ca3af' }}>Zadne projekty</div>}
      {filtered.map(p => (
        <div key={p.id} style={{ background: '#fff', borderRadius: 10, padding: '18px 20px', border: '1px solid #f3f4f6', borderLeft: `4px solid ${STATUS_COLOR[p.status] || '#e5e7eb'}` }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4 }}>
                <span style={{ fontWeight: 700, fontSize: 15, color: '#111827' }}>{p.project_name}</span>
                <span style={{ background: STATUS_BG[p.status], color: STATUS_COLOR[p.status], fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 20 }}>
                  {t(`status${p.status.charAt(0).toUpperCase() + p.status.slice(1)}`)}
                </span>
              </div>
              <div style={{ fontSize: 13, color: '#6b7280', display: 'flex', flexWrap: 'wrap', gap: '3px 16px' }}>
                <span>{p.company_name}</span><span>{p.end_customer}</span>{p.end_customer_ico && <span>IČ: {p.end_customer_ico}</span>}{p.subdistributor_name && <span style={{color:'#0e76bc',fontWeight:600}}>🏪 {p.subdistributor_name}</span>}{p.realization_date && <span>📆 {new Date(p.realization_date + '-01').toLocaleDateString('cs-CZ', {month:'long',year:'numeric'})}</span>}
                <span>{p.submitted_by_name}</span>
                {p.estimated_value && <span>{Number(p.estimated_value).toLocaleString()} {p.currency}</span>}
                <span>{new Date(p.created_at).toLocaleDateString('cs-CZ')}</span>
              </div>
              {p.items && p.items.length > 0 && (
                <div style={{ marginTop: 8, border: '1px solid #f3f4f6', borderRadius: 6, overflow: 'hidden' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                    <thead><tr style={{ background: '#f9fafb' }}>
                      <th style={{ padding: '5px 10px', textAlign: 'left', color: '#6b7280', fontWeight: 600 }}>Produkt</th>
                      <th style={{ padding: '5px 10px', textAlign: 'left', color: '#6b7280', fontWeight: 600 }}>SKU</th>
                      <th style={{ padding: '5px 10px', textAlign: 'center', color: '#6b7280', fontWeight: 600 }}>Mn.</th>
                      <th style={{ padding: '5px 10px', textAlign: 'left', color: '#6b7280', fontWeight: 600 }}>Pozn.</th>
                    </tr></thead>
                    <tbody>
                      {p.items.map((item, i) => (
                        <tr key={i} style={{ borderTop: '1px solid #f3f4f6' }}>
                          <td style={{ padding: '5px 10px', fontWeight: 600 }}>{item.product_name}</td>
                          <td style={{ padding: '5px 10px', color: '#9ca3af', fontFamily: 'monospace' }}>{item.product_sku}</td>
                          <td style={{ padding: '5px 10px', textAlign: 'center', fontWeight: 700 }}>{item.quantity}</td>
                          <td style={{ padding: '5px 10px', color: '#6b7280' }}>{item.note}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              {p.admin_note && <div style={{ fontSize: 13, marginTop: 6, background: '#f9fafb', padding: '6px 10px', borderRadius: 6 }}>{p.admin_note}</div>}
            </div>
            <BtnSecondary onClick={() => setEditing(editing === p.id ? null : p.id)}>
              {editing === p.id ? 'Zavrit' : 'Vyridit'}
            </BtnSecondary>
          </div>
          {editing === p.id && (
            <EditProjectInline p={p} t={t} onSave={(data) => updateProject(p.id, data)} />
          )}
        </div>
      ))}
      </div>
    </div>
  );
}

function EditProjectInline({ p, t, onSave }) {
  const [status, setStatus] = useState(p.status);
  const [note, setNote] = useState(p.admin_note || '');
  const [discount, setDiscount] = useState(p.discount_percent || '');
  return (
    <div style={{ marginTop: 14, paddingTop: 14, borderTop: '1px solid #f3f4f6', display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
      <div>
        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Stav</label>
        <select value={status} onChange={e => setStatus(e.target.value)}
          style={{ padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, background: '#fff', fontFamily: 'inherit' }}>
          {STATUS_OPTS.map(s => <option key={s} value={s}>{t(`status${s.charAt(0).toUpperCase() + s.slice(1)}`)}</option>)}
        </select>
      </div>
      <div>
        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Sleva (%)</label>
        <input type="number" value={discount} onChange={e => setDiscount(e.target.value)} min="0" max="100"
          style={{ width: 80, padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, fontFamily: 'inherit' }} />
      </div>
      <div style={{ flex: 1, minWidth: 200 }}>
        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Poznamka pro prodejce</label>
        <input value={note} onChange={e => setNote(e.target.value)}
          style={{ width: '100%', padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box' }} />
      </div>
      <BtnPrimary onClick={() => onSave({ status, admin_note: note, discount_percent: discount || null })}>Ulozit</BtnPrimary>
    </div>
  );
}

function UsersTab({ apiFetch }) {
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [search, setSearch] = useState('');
  const [filterCountry, setFilterCountry] = useState('');
  const [filterCompany, setFilterCompany] = useState('');
  const [filterStatus, setFilterStatus] = useState('active');
  const [editForm, setEditForm] = useState({});
  const { user: currentUser } = useAuth();
  const empty = { email: '', password: '', first_name: '', last_name: '', company_name: '', company_ico: '', country: 'CZ', lang: 'cs', role: 'user' };
  const [form, setForm] = useState(empty);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const setEdit = (k, v) => setEditForm(f => ({ ...f, [k]: v }));
  const load = () => apiFetch('/admin/users').then(setUsers);
  useEffect(() => { load(); }, []);

  const toggleActive = async (u) => {
    await apiFetch(`/admin/users/${u.id}`, { method: 'PUT', body: JSON.stringify({ is_active: u.is_active ? 0 : 1, role: u.role, status: u.is_active ? 'inactive' : 'active' }) });
    load();
  };

  const handleDelete = async (u) => {
    const name = `${u.first_name || ''} ${u.last_name || ''}`.trim() + ` <${u.email}>`;
    try {
      const info = await apiFetch(`/admin/users/${u.id}/links`);
      const blocking = (info.blocking || []).filter(b => b.count > 0);
      let force = false;
      if (blocking.length > 0) {
        const list = blocking.map(b => `  • ${b.table}: ${b.count}`).join('\n');
        if (!window.confirm(`Uživatel ${name} má navázané záznamy:\n${list}\n\nPokud jde o testovacího uživatele, můžete ho smazat i s těmito záznamy (nevratné).\nU skutečného partnera raději použijte Deaktivovat.\n\nSmazat uživatele VČETNĚ navázaných záznamů?`)) return;
        force = true;
      } else {
        if (!window.confirm(`Opravdu trvale smazat uživatele ${name}?\nTuto akci nelze vrátit.`)) return;
      }
      await apiFetch(`/admin/users/${u.id}${force ? '?force=1' : ''}`, { method: 'DELETE' });
      if (editing === u.id) setEditing(null);
      load();
    } catch (e) { alert(e.message); }
  };

  const handleCreate = async () => {
    try {
      await apiFetch('/admin/users', { method: 'POST', body: JSON.stringify(form) });
      setShowForm(false); setForm(empty); load();
    } catch (e) { alert(e.message); }
  };

  const startEdit = (u) => {
    setEditing(u.id);
    setEditForm({ title: u.title||'', first_name: u.first_name, last_name: u.last_name, email: u.email, company_name: u.company_name || '', company_ico: u.company_ico || '', vat_number: u.vat_number||'', country: u.country || 'CZ', address: u.address||'', city: u.city||'', zip: u.zip||'', phone: u.phone||'', lang: u.lang || 'cs', role: u.role, is_active: u.is_active, status: u.status||'active', interest_news: u.interest_news, interest_training: u.interest_training, subdistributor_id: u.subdistributor_id||'', password: '' });
  };

  const handleSaveEdit = async () => {
    try {
      await apiFetch(`/admin/users/${editing}/full`, { method: 'PUT', body: JSON.stringify(editForm) });
      setEditing(null); load();
    } catch (e) { alert(e.message); }
  };

  return (
    <div>
      {/* Filters */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap' }}>
        <input
          placeholder="Hledat jméno, příjmení, email, telefon..."
          value={search} onChange={e => setSearch(e.target.value)}
          style={{ flex: 2, minWidth: 220, padding: '8px 12px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', outline: 'none' }}
        />
        <select value={filterCountry} onChange={e => setFilterCountry(e.target.value)}
          style={{ flex: 1, minWidth: 120, padding: '8px 12px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', background: '#fff', cursor: 'pointer' }}>
          <option value="">Všechny státy</option>
          {[...new Set(users.map(u => u.country).filter(Boolean))].sort().map(c => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
        <select value={filterCompany} onChange={e => setFilterCompany(e.target.value)}
          style={{ flex: 1, minWidth: 160, padding: '8px 12px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', background: '#fff', cursor: 'pointer' }}>
          <option value="">Všechny firmy</option>
          {[...new Set(users.map(u => u.company_name).filter(Boolean))].sort().map(c => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
        <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}
          style={{ flex: 1, minWidth: 140, padding: '8px 12px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', background: '#fff', cursor: 'pointer' }}>
          <option value="active">Jen aktivní ({users.filter(u => u.status !== 'pending' && u.is_active).length})</option>
          <option value="inactive">Neaktivní / zamítnutí ({users.filter(u => u.status !== 'pending' && !u.is_active).length})</option>
          <option value="all">Všichni</option>
        </select>
        {(search || filterCountry || filterCompany || filterStatus !== 'active') && (
          <button onClick={() => { setSearch(''); setFilterCountry(''); setFilterCompany(''); setFilterStatus('active'); }}
            style={{ padding: '8px 14px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, background: '#f9fafb', cursor: 'pointer', fontFamily: 'inherit', color: '#6b7280' }}>
            ✕ Zrušit
          </button>
        )}
      </div>

      {/* Pending registrations */}
      {users.filter(u => u.status === 'pending').length > 0 && (
        <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 10, padding: 16, marginBottom: 20 }}>
          <div style={{ fontWeight: 700, fontSize: 14, color: '#92400e', marginBottom: 12 }}>
            ⏳ Čekající registrace ({users.filter(u => u.status === 'pending').length})
          </div>
          {users.filter(u => u.status === 'pending').map(u => (
            <div key={u.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #fde68a', gap: 12, flexWrap: 'wrap' }}>
              <div>
                <div style={{ fontWeight: 600, fontSize: 13 }}>{u.first_name} {u.last_name} — {u.company_name}</div>
                <div style={{ fontSize: 12, color: '#6b7280' }}>{u.email} · IČ: {u.company_ico} · {u.country}</div>
                {u.interest_news || u.interest_training ? (
                  <div style={{ fontSize: 11, color: '#0369a1', marginTop: 2 }}>
                    {u.interest_news ? '📰 Novinky ' : ''}{u.interest_training ? '🎓 Školení' : ''}
                  </div>
                ) : null}
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <BtnPrimary onClick={async () => { await apiFetch(`/admin/users/${u.id}`, { method: 'PUT', body: JSON.stringify({ is_active: 1, role: 'user', status: 'active' }) }); load(); }}>Schválit</BtnPrimary>
                <BtnDanger onClick={async () => { if (window.confirm('Zamítnout registraci?')) { await apiFetch(`/admin/users/${u.id}/full`, { method: 'PUT', body: JSON.stringify({ ...u, is_active: 0, status: 'rejected' }) }); load(); } }}>Zamítnout</BtnDanger>
              </div>
            </div>
          ))}
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <span style={{ fontWeight: 700, fontSize: 15, color: '#374151' }}>
          {users.filter(u => {
            if (u.status === 'pending') return false;
            if (filterCountry && u.country !== filterCountry) return false;
            if (filterCompany && u.company_name !== filterCompany) return false;
            if (search) { const q = search.toLowerCase(); return (u.first_name||'').toLowerCase().includes(q) || (u.last_name||'').toLowerCase().includes(q) || (u.email||'').toLowerCase().includes(q) || (u.phone||'').toLowerCase().includes(q); }
            return true;
          }).length} / {users.filter(u => u.status !== 'pending').length} uživatelů
        </span>
        <BtnPrimary onClick={() => setShowForm(!showForm)}>{showForm ? 'Zavrit' : '+ Novy uzivatel'}</BtnPrimary>
      </div>
      {showForm && (
        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 10, padding: 20, marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 15, fontWeight: 700 }}>Novy uzivatel</h3>
          <Grid2>
            <Inp label="Jmeno" value={form.first_name} onChange={v => set('first_name', v)} required />
            <Inp label="Prijmeni" value={form.last_name} onChange={v => set('last_name', v)} required />
            <Inp label="E-mail" value={form.email} onChange={v => set('email', v)} type="email" required />
            <Inp label="Telefon" value={form.phone||''} onChange={v => set('phone', v)} />
            <Inp label="Heslo" value={form.password} onChange={v => set('password', v)} type="password" required />
            <Inp label="Nazev firmy" value={form.company_name} onChange={v => set('company_name', v)} />
            <Inp label="ICO" value={form.company_ico} onChange={v => set('company_ico', v)} required />
            <Inp label="DIC" value={form.vat_number||''} onChange={v => set('vat_number', v)} />
            <Inp label="Adresa" value={form.address||''} onChange={v => set('address', v)} />
            <Inp label="Mesto" value={form.city||''} onChange={v => set('city', v)} />
            <Inp label="PSC" value={form.zip||''} onChange={v => set('zip', v)} />
            <Sel label="Zeme" value={form.country||'CZ'} onChange={v => set('country', v)} options={[{ value: 'CZ', label: 'Ceska republika' }, { value: 'SK', label: 'Slovensko' }, { value: 'RO', label: 'Rumunsko' }, { value: 'HU', label: 'Madarsko' }, { value: 'PL', label: 'Polsko' }, { value: 'DE', label: 'Nemecko' }, { value: 'AT', label: 'Rakousko' }]} />
            <Sel label="Role" value={form.role} onChange={v => set('role', v)} options={[{ value: 'user', label: 'Uzivatel' }, { value: 'subdistributor', label: 'Subdistributor' }, { value: 'admin', label: 'Admin' }]} />
            <Sel label="Jazyk" value={form.lang} onChange={v => set('lang', v)} options={[{ value: 'cs', label: 'Čeština' }, { value: 'sk', label: 'Slovenčina' }, { value: 'ro', label: 'Română' }, { value: 'en', label: 'English' }, { value: 'hu', label: 'Magyar' }]} />
          </Grid2>
          <div style={{ display: 'flex', gap: 10 }}>
            <BtnPrimary onClick={handleCreate} disabled={!form.email || !form.password || !form.first_name || !form.last_name || !form.company_ico}>Vytvorit</BtnPrimary>
            <BtnSecondary onClick={() => setShowForm(false)}>Zrusit</BtnSecondary>
          </div>
        </div>
      )}

      {editing !== null && (
        <div style={{ background: '#f9fafb', border: '2px solid #0e76bc', borderRadius: 10, padding: 20, marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 15, fontWeight: 700, color: '#0e76bc' }}>Upravit uzivatele</h3>
          <Grid2>
            <Inp label="Titul" value={editForm.title||''} onChange={v => setEdit('title', v)} />
            <Inp label="Jmeno" value={editForm.first_name} onChange={v => setEdit('first_name', v)} required />
            <Inp label="Prijmeni" value={editForm.last_name} onChange={v => setEdit('last_name', v)} required />
            <Inp label="E-mail" value={editForm.email} onChange={v => setEdit('email', v)} type="email" required />
            <Inp label="Telefon" value={editForm.phone||''} onChange={v => setEdit('phone', v)} />
            <Inp label="Nove heslo (nechat prazdne)" value={editForm.password} onChange={v => setEdit('password', v)} type="password" />
            <Inp label="Nazev firmy" value={editForm.company_name} onChange={v => setEdit('company_name', v)} />
            <Inp label="ICO" value={editForm.company_ico} onChange={v => setEdit('company_ico', v)} />
            <Inp label="DIC" value={editForm.vat_number||''} onChange={v => setEdit('vat_number', v)} />
            <Inp label="Adresa" value={editForm.address||''} onChange={v => setEdit('address', v)} />
            <Inp label="Mesto" value={editForm.city||''} onChange={v => setEdit('city', v)} />
            <Inp label="PSC" value={editForm.zip||''} onChange={v => setEdit('zip', v)} />
            <Sel label="Zeme" value={editForm.country} onChange={v => setEdit('country', v)} options={[{ value: 'CZ', label: 'Ceska republika' }, { value: 'SK', label: 'Slovensko' }, { value: 'RO', label: 'Rumunsko' }, { value: 'HU', label: 'Madarsko' }, { value: 'PL', label: 'Polsko' }, { value: 'DE', label: 'Nemecko' }, { value: 'AT', label: 'Rakousko' }]} />
            <Sel label="Role" value={editForm.role} onChange={v => setEdit('role', v)} options={[{ value: 'user', label: 'Uzivatel' }, { value: 'subdistributor', label: 'Subdistributor' }, { value: 'admin', label: 'Admin' }]} />
            <Sel label="Jazyk" value={editForm.lang} onChange={v => setEdit('lang', v)} options={[{ value: 'cs', label: 'Čeština' }, { value: 'sk', label: 'Slovenčina' }, { value: 'ro', label: 'Română' }, { value: 'en', label: 'English' }, { value: 'hu', label: 'Magyar' }]} />
            <Sel label="Stav" value={editForm.is_active} onChange={v => setEdit('is_active', Number(v))} options={[{ value: 1, label: 'Aktivni' }, { value: 0, label: 'Neaktivni' }]} />
          </Grid2>
          {editForm.role === 'subdistributor' && (
            <div style={{ gridColumn: '1 / -1', marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#0e76bc', marginBottom: 4 }}>Propojený subdistributor</label>
              <SubdistSelector value={editForm.subdistributor_id||''} onChange={v => setEdit('subdistributor_id', v ? Number(v) : null)} apiFetch={apiFetch} />
            </div>
          )}
          <div style={{ marginTop: 8, padding: '10px 14px', background: '#f9fafb', borderRadius: 8, fontSize: 13, color: '#6b7280' }}>
            <strong>Zájem o:</strong>
            {editForm.interest_news ? ' 📰 Novinky' : ''}{editForm.interest_training ? ' 🎓 Školení a výstavy' : ''}
            {!editForm.interest_news && !editForm.interest_training ? ' žádný' : ''}
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <BtnPrimary onClick={handleSaveEdit}>Ulozit zmeny</BtnPrimary>
            <BtnSecondary onClick={() => setEditing(null)}>Zrusit</BtnSecondary>
          </div>
        </div>
      )}

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#f9fafb', borderBottom: '2px solid #e5e7eb' }}>
              {['Jmeno', 'E-mail', 'Firma', 'Role', 'Jazyk', 'Stav', 'Akce'].map(h => (
                <th key={h} style={{ padding: '10px 12px', textAlign: 'left', color: '#6b7280', fontWeight: 600, fontSize: 12 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {users.filter(u => {
                if (u.status === 'pending') return false;
                if (filterStatus === 'active' && !u.is_active) return false;
                if (filterStatus === 'inactive' && u.is_active) return false;
                if (filterCountry && u.country !== filterCountry) return false;
                if (filterCompany && u.company_name !== filterCompany) return false;
                if (search) {
                  const q = search.toLowerCase();
                  return (u.first_name||'').toLowerCase().includes(q) ||
                         (u.last_name||'').toLowerCase().includes(q) ||
                         (u.email||'').toLowerCase().includes(q) ||
                         (u.phone||'').toLowerCase().includes(q);
                }
                return true;
              }).map(u => (
              <tr key={u.id} style={{ borderBottom: '1px solid #f3f4f6', background: editing === u.id ? '#e8f4fc' : 'transparent', opacity: u.is_active ? 1 : 0.6 }}>
                <td style={{ padding: '10px 12px', fontWeight: 600, color: '#111827' }}>{u.first_name} {u.last_name}</td>
                <td style={{ padding: '10px 12px', color: '#6b7280' }}>{u.email}</td>
                <td style={{ padding: '10px 12px', color: '#374151' }}>{u.company_name}</td>
                <td style={{ padding: '10px 12px' }}>
                  <span style={{ background: u.role === 'admin' ? '#e8f4fc' : '#f0f9ff', color: u.role === 'admin' ? '#0e76bc' : '#0369a1', fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 6 }}>
                    {u.role}
                  </span>
                </td>
                <td style={{ padding: '10px 12px', color: '#374151' }}>{u.lang && u.lang.toUpperCase()}</td>
                <td style={{ padding: '10px 12px' }}>
                  <span style={{ background: u.is_active ? '#f0fdf4' : '#f9fafb', color: u.is_active ? '#166534' : '#9ca3af', fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 6 }}>
                    {u.is_active ? 'Aktivni' : (u.status === 'rejected' ? 'Zamitnuto' : 'Neaktivni')}
                  </span>
                </td>
                <td style={{ padding: '10px 12px' }}>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <BtnSecondary onClick={() => editing === u.id ? setEditing(null) : startEdit(u)}>
                      {editing === u.id ? 'Zavrit' : 'Upravit'}
                    </BtnSecondary>
                    <button onClick={() => toggleActive(u)} style={{ background: 'none', border: '1px solid #e5e7eb', color: '#374151', borderRadius: 6, padding: '4px 10px', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit' }}>
                      {u.is_active ? 'Deaktivovat' : 'Aktivovat'}
                    </button>
                    {currentUser?.id !== u.id && (
                      <BtnDanger onClick={() => handleDelete(u)}>Smazat</BtnDanger>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}






// ─── TRANSLATIONS TAB ────────────────────────────────────────────────────────

const DEFAULT_KEYS = {
  cs: {
    news: 'Novinky', trainings: 'Školení', exhibitions: 'Výstavy', projects: 'Projekty',
    catalog: 'Katalog', loans: 'Zápůjčky', contact: 'Kontakt',
    newsTitle: 'Novinky', trainingsTitle: 'Školení a certifikace', exhibitionsTitle: 'Výstavy',
    projectsTitle: 'Projektová ochrana', projectsSubtitle: 'Požádejte o projektovou ochranu pro vaše obchodní příležitosti',
    contactTitle: 'Kontakt', contactSubtitle: 'Váš distributor Grandstream',
    loginTitle: 'Přihlášení do portálu', loginSubtitle: 'Grandstream Partner Portal',
    noNews: 'Zatím žádné novinky.', noTrainings: 'Momentálně nejsou k dispozici žádná školení.',
    noExhibitions: 'Momentálně nejsou plánovány žádné výstavy.', noProjects: 'Zatím žádné projekty.',
    registerSuccess: 'Byli jste úspěšně přihlášeni. Potvrzení bylo zasláno na váš e-mail.',
    statusPending: 'Čeká na schválení', statusApproved: 'Schváleno', statusRejected: 'Zamítnuto',
  },
  sk: {
    news: 'Novinky', trainings: 'Školenia', exhibitions: 'Výstavy', projects: 'Projekty',
    catalog: 'Katalog', loans: 'Zápůjčky', contact: 'Kontakt',
    newsTitle: 'Novinky', trainingsTitle: 'Školenia a certifikácie', exhibitionsTitle: 'Výstavy',
    projectsTitle: 'Projektová ochrana', projectsSubtitle: 'Požiadajte o projektovú ochranu pre vaše obchodné príležitosti',
    contactTitle: 'Kontakt', contactSubtitle: 'Váš distribútor Grandstream',
    loginTitle: 'Prihlásenie do portálu', loginSubtitle: 'Grandstream Partner Portal',
    noNews: 'Zatiaľ žiadne novinky.', noTrainings: 'Momentálne nie sú k dispozícii žiadne školenia.',
    noExhibitions: 'Momentálne nie sú plánované žiadne výstavy.', noProjects: 'Zatiaľ žiadne projekty.',
    registerSuccess: 'Boli ste úspešne prihlásení. Potvrdenie bolo odoslané na váš e-mail.',
    statusPending: 'Čaká na schválenie', statusApproved: 'Schválené', statusRejected: 'Zamietnuté',
  },
  ro: {
    news: 'Noutăți', trainings: 'Training-uri', exhibitions: 'Expoziții', projects: 'Proiecte',
    catalog: 'Catalog', loans: 'Împrumuturi', contact: 'Contact',
    newsTitle: 'Noutăți', trainingsTitle: 'Training-uri și certificări', exhibitionsTitle: 'Expoziții',
    projectsTitle: 'Protecție proiect', projectsSubtitle: 'Solicitați protecție pentru oportunitățile dvs. de afaceri',
    contactTitle: 'Contact', contactSubtitle: 'Distribuitorul dvs. Grandstream',
    loginTitle: 'Autentificare în portal', loginSubtitle: 'Grandstream Partner Portal',
    noNews: 'Nicio noutate momentan.', noTrainings: 'Niciun training disponibil momentan.',
    noExhibitions: 'Nicio expoziție planificată momentan.', noProjects: 'Niciun proiect momentan.',
    registerSuccess: 'V-ați înscris cu succes. Confirmarea a fost trimisă pe e-mailul dvs.',
    statusPending: 'În așteptare', statusApproved: 'Aprobat', statusRejected: 'Respins',
  },
  en: {
    news: 'News', trainings: 'Trainings', exhibitions: 'Exhibitions', projects: 'Projects',
    catalog: 'Catalog', loans: 'Loans', contact: 'Contact',
    newsTitle: 'News', trainingsTitle: 'Trainings & Certifications', exhibitionsTitle: 'Exhibitions',
    projectsTitle: 'Project Protection', projectsSubtitle: 'Request project protection for your business opportunities',
    contactTitle: 'Contact', contactSubtitle: 'Your Grandstream Distributor',
    loginTitle: 'Partner Portal Login', loginSubtitle: 'Grandstream Partner Portal',
    noNews: 'No news yet.', noTrainings: 'No trainings available at the moment.',
    noExhibitions: 'No exhibitions planned at the moment.', noProjects: 'No projects yet.',
    registerSuccess: 'Successfully registered. Confirmation sent to your email.',
    statusPending: 'Pending', statusApproved: 'Approved', statusRejected: 'Rejected',
  },
  hu: {
    news: 'Hírek', trainings: 'Képzések', exhibitions: 'Kiállítások', projects: 'Projektek',
    catalog: 'Katalógus', loans: 'Kölcsönzés', contact: 'Kapcsolat',
    newsTitle: 'Hírek', trainingsTitle: 'Képzések és tanúsítványok', exhibitionsTitle: 'Kiállítások',
    projectsTitle: 'Projektvédelem', projectsSubtitle: 'Kérjen projektvédelmet üzleti lehetőségeihez',
    contactTitle: 'Kapcsolat', contactSubtitle: 'Az Ön Grandstream disztribútora',
    loginTitle: 'Partner Portal bejelentkezés', loginSubtitle: 'Grandstream Partner Portal',
    noNews: 'Még nincsenek hírek.', noTrainings: 'Jelenleg nincs elérhető képzés.',
    noExhibitions: 'Jelenleg nincs tervezett kiállítás.', noProjects: 'Még nincsenek projektek.',
    registerSuccess: 'Sikeresen regisztrált. Visszaigazolás elküldve az e-mail címére.',
    statusPending: 'Függőben', statusApproved: 'Jóváhagyva', statusRejected: 'Elutasítva',
  },
};

const LANG_LABELS = { cs: '🇨🇿 Čeština', sk: '🇸🇰 Slovenčina', ro: '🇷🇴 Română', en: '🇬🇧 English', hu: '🇭🇺 Magyar' };

function TranslationsTab({ apiFetch }) {
  const [data, setData] = useState({ cs: {}, sk: {}, ro: {} });
  const [activeLang, setActiveLang] = useState('cs');
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    apiFetch('/admin/translations').then(d => {
      if (d && Object.keys(d).length > 0) setData(d);
      else setData(JSON.parse(JSON.stringify(DEFAULT_KEYS)));
    }).catch(() => setData(JSON.parse(JSON.stringify(DEFAULT_KEYS))));
  }, []);

  const set = (lang, key, val) => setData(d => ({ ...d, [lang]: { ...d[lang], [key]: val } }));

  const handleSave = async () => {
    try {
      await apiFetch('/admin/translations', { method: 'PUT', body: JSON.stringify({ translations: data }) });
      setSaved(true); setTimeout(() => setSaved(false), 3000);
    } catch(e) { alert(e.message); }
  };

  const handleReset = () => { if (window.confirm('Obnovit výchozí překlady?')) setData(JSON.parse(JSON.stringify(DEFAULT_KEYS))); };

  const keys = Object.keys(DEFAULT_KEYS[activeLang] || {});

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div style={{ display: 'flex', gap: 8 }}>
          {['cs', 'sk', 'ro', 'en', 'hu'].map(l => (
            <button key={l} onClick={() => setActiveLang(l)} style={{ padding: '7px 16px', border: `2px solid ${activeLang === l ? '#0e76bc' : '#e5e7eb'}`, background: activeLang === l ? '#e8f4fc' : '#fff', color: activeLang === l ? '#0e76bc' : '#374151', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
              {LANG_LABELS[l]}
            </button>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {saved && <span style={{ fontSize: 13, color: '#166534', fontWeight: 600 }}>✓ Uloženo</span>}
          <button onClick={handleReset} style={{ background: 'none', border: '1px solid #e5e7eb', color: '#6b7280', borderRadius: 6, padding: '7px 12px', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit' }}>Obnovit výchozí</button>
          <button onClick={handleSave} style={{ background: 'linear-gradient(135deg, #0e76bc, #0b5e96)', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>Uložit překlady</button>
        </div>
      </div>

      <div style={{ background: '#f9fafb', borderRadius: 10, padding: 16, marginBottom: 16, fontSize: 12, color: '#6b7280' }}>
        💡 Změny se projeví po obnovení stránky uživateli. Upravujete překlady pro jazyk: <strong>{LANG_LABELS[activeLang]}</strong>
      </div>

      <div style={{ display: 'grid', gap: 8 }}>
        {keys.map(key => (
          <div key={key} style={{ display: 'grid', gridTemplateColumns: '200px 1fr', gap: 12, alignItems: 'center', background: '#fff', padding: '10px 14px', borderRadius: 8, border: '1px solid #f3f4f6' }}>
            <div style={{ fontSize: 12, fontFamily: 'monospace', color: '#6b7280', fontWeight: 600 }}>{key}</div>
            <input
              value={data[activeLang]?.[key] || ''}
              onChange={e => set(activeLang, key, e.target.value)}
              style={{ padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 6, fontSize: 13, fontFamily: 'inherit', outline: 'none', width: '100%', boxSizing: 'border-box' }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}



// ─── PAGES TAB ───────────────────────────────────────────────────────────────

const LANG_LIST = ['cs', 'sk', 'ro', 'en', 'hu'];
const LANG_FLAG = { cs: '🇨🇿', sk: '🇸🇰', ro: '🇷🇴', en: '🇬🇧', hu: '🇭🇺' };

function PagesTab({ apiFetch }) {
  const [page, setPage] = useState(null);
  const [activeLang, setActiveLang] = useState('cs');
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    apiFetch('/pages/gdpr').then(setPage).catch(() => {});
  }, []);

  const set = (key, val) => setPage(p => ({ ...p, [key]: val }));

  const handleSave = async () => {
    try {
      await apiFetch('/admin/pages/gdpr', { method: 'PUT', body: JSON.stringify(page) });
      setSaved(true); setTimeout(() => setSaved(false), 3000);
    } catch(e) { alert(e.message); }
  };

  if (!page) return <div style={{ textAlign: 'center', padding: 40, color: '#9ca3af' }}>Načítám...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>GDPR — Zásady ochrany osobních údajů</h3>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {saved && <span style={{ fontSize: 13, color: '#166534', fontWeight: 600 }}>✓ Uloženo</span>}
          <BtnPrimary onClick={handleSave}>Uložit</BtnPrimary>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 6, marginBottom: 16 }}>
        {LANG_LIST.map(l => (
          <button key={l} onClick={() => setActiveLang(l)} style={{ padding: '6px 14px', border: `2px solid ${activeLang === l ? '#0e76bc' : '#e5e7eb'}`, background: activeLang === l ? '#e8f4fc' : '#fff', color: activeLang === l ? '#0e76bc' : '#374151', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
            {LANG_FLAG[l]} {l.toUpperCase()}
          </button>
        ))}
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Název stránky</label>
        <input value={page[`title_${activeLang}`] || ''} onChange={e => set(`title_${activeLang}`, e.target.value)}
          style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 14, fontFamily: 'inherit', boxSizing: 'border-box' }} />
      </div>

      <div>
        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Obsah stránky</label>
        <textarea value={page[`content_${activeLang}`] || ''} onChange={e => set(`content_${activeLang}`, e.target.value)}
          rows={20} style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box', resize: 'vertical', lineHeight: 1.6 }} />
      </div>
    </div>
  );
}

// ─── FAVORITES TAB ───────────────────────────────────────────────────────────

function FavoritesTab({ apiFetch }) {
  const [stats, setStats] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);

  useEffect(() => {
    apiFetch('/admin/favorites/stats').then(setStats).catch(() => setStats([]));
  }, []);

  const showUsers = async (product) => {
    if (selectedProduct?.id === product.id) { setSelectedProduct(null); setUsers([]); return; }
    setSelectedProduct(product);
    setLoadingUsers(true);
    apiFetch(`/admin/favorites/users/${product.id}`).then(setUsers).finally(() => setLoadingUsers(false));
  };

  const imageBase = window.location.origin.replace(':3000', ':3001');

  return (
    <div>
      <div style={{ marginBottom: 16, fontSize: 15, fontWeight: 700, color: '#374151' }}>
        {stats.length} produktů s oblíbeními
      </div>

      {stats.length === 0 && (
        <div style={{ textAlign: 'center', padding: 40, color: '#9ca3af' }}>Žádné oblíbené produkty.</div>
      )}

      <div style={{ display: 'grid', gap: 8 }}>
        {stats.map(p => {
          const imgSrc = p.image_url ? (p.image_url.startsWith('http') ? p.image_url : `${imageBase}${p.image_url}`) : null;
          const isOpen = selectedProduct?.id === p.id;
          return (
            <div key={p.id} style={{ background: '#fff', borderRadius: 10, border: `1px solid ${isOpen ? '#0e76bc' : '#f3f4f6'}`, overflow: 'hidden' }}>
              <div onClick={() => showUsers(p)} style={{ padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 14, cursor: 'pointer' }}>
                {imgSrc && <img src={imgSrc} alt={p.name} style={{ width: 48, height: 48, objectFit: 'contain', borderRadius: 6, background: '#f9fafb', flexShrink: 0 }} />}
                {!imgSrc && <div style={{ width: 48, height: 48, background: '#f9fafb', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0 }}>📦</div>}
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: 14, color: '#111827' }}>{p.name}</div>
                  {p.part_number && <div style={{ fontSize: 12, color: '#9ca3af', fontFamily: 'monospace' }}>{p.part_number}</div>}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ background: '#e8f4fc', color: '#0e76bc', fontWeight: 700, fontSize: 14, padding: '4px 12px', borderRadius: 20 }}>
                    👍 {p.favorite_count}
                  </span>
                  <span style={{ color: '#9ca3af', fontSize: 12 }}>{isOpen ? '▲' : '▼'}</span>
                </div>
              </div>

              {isOpen && (
                <div style={{ borderTop: '1px solid #f3f4f6', padding: '12px 16px', background: '#fafafa' }}>
                  {loadingUsers ? (
                    <div style={{ textAlign: 'center', padding: 20, color: '#9ca3af' }}>Načítám...</div>
                  ) : (
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                      <thead>
                        <tr>
                          <th style={{ padding: '6px 10px', textAlign: 'left', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #e5e7eb' }}>Uživatel</th>
                          <th style={{ padding: '6px 10px', textAlign: 'left', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #e5e7eb' }}>Firma</th>
                          <th style={{ padding: '6px 10px', textAlign: 'left', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #e5e7eb' }}>E-mail</th>
                          <th style={{ padding: '6px 10px', textAlign: 'left', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #e5e7eb' }}>Oblíbeno</th>
                        </tr>
                      </thead>
                      <tbody>
                        {users.map(u => (
                          <tr key={u.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                            <td style={{ padding: '8px 10px', fontWeight: 600 }}>{u.first_name} {u.last_name}</td>
                            <td style={{ padding: '8px 10px', color: '#6b7280' }}>{u.company_name}</td>
                            <td style={{ padding: '8px 10px', color: '#0e76bc' }}><a href={`mailto:${u.email}`} style={{ color: 'inherit' }}>{u.email}</a></td>
                            <td style={{ padding: '8px 10px', color: '#9ca3af', fontSize: 12 }}>{new Date(u.created_at).toLocaleDateString('cs-CZ')}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─── CATALOG CATEGORIES TAB ──────────────────────────────────────────────────

function CatalogCategoriesTab({ apiFetch }) {
  const [categories, setCategories] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const empty = { name: '', name_sk: '', name_ro: '', name_en: '', name_hu: '', parent_id: '', sort_order: 0 };
  const [form, setForm] = useState(empty);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const load = () => apiFetch('/catalog/categories').then(setCategories);
  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    try {
      const data = { ...form, parent_id: form.parent_id || null };
      if (editing) await apiFetch(`/catalog/categories/${editing}`, { method: 'PUT', body: JSON.stringify(data) });
      else await apiFetch('/catalog/categories', { method: 'POST', body: JSON.stringify(data) });
      setShowForm(false); setEditing(null); setForm(empty); load();
    } catch (e) { alert(e.message); }
  };

  const handleEdit = (c) => { setForm({ name: c.name, name_sk: c.name_sk||'', name_ro: c.name_ro||'', name_en: c.name_en||'', name_hu: c.name_hu||'', parent_id: c.parent_id||'', sort_order: c.sort_order||0 }); setEditing(c.id); setShowForm(true); };
  const handleDelete = async (id) => { if (!window.confirm('Smazat kategorii? Podkategorie budou přesunuty o úroveň výš.')) return; await apiFetch(`/catalog/categories/${id}`, { method: 'DELETE' }); load(); };

  const parentOpts = categories.filter(c => !editing || c.id !== editing);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <span style={{ fontWeight: 700, fontSize: 15, color: '#374151' }}>{categories.length} kategorií</span>
        <BtnPrimary onClick={() => { setForm(empty); setEditing(null); setShowForm(!showForm); }}>
          {showForm && !editing ? 'Zavřít' : '+ Přidat kategorii'}
        </BtnPrimary>
      </div>

      {showForm && (
        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 10, padding: 20, marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 15, fontWeight: 700 }}>{editing ? 'Upravit kategorii' : 'Nová kategorie'}</h3>
          <Grid3>
            <Inp label="Název (CS)" value={form.name} onChange={v => set('name', v)} required />
            <Inp label="Název (SK)" value={form.name_sk} onChange={v => set('name_sk', v)} />
            <Inp label="Název (RO)" value={form.name_ro} onChange={v => set('name_ro', v)} />
            <Inp label="Název (EN)" value={form.name_en} onChange={v => set('name_en', v)} />
            <Inp label="Název (HU)" value={form.name_hu} onChange={v => set('name_hu', v)} />
          </Grid3>
          <Grid2>
            <div>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Nadřazená kategorie</label>
              <select value={form.parent_id||''} onChange={e => set('parent_id', e.target.value||null)} style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', background: '#fff' }}>
                <option value="">-- Kořenová kategorie --</option>
                {parentOpts.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
            <Inp label="Pořadí" value={form.sort_order} onChange={v => set('sort_order', Number(v))} type="number" />
          </Grid2>
          <div style={{ display: 'flex', gap: 10 }}>
            <BtnPrimary onClick={handleSave} disabled={!form.name}>Uložit</BtnPrimary>
            <BtnSecondary onClick={() => { setShowForm(false); setEditing(null); }}>Zrušit</BtnSecondary>
          </div>
        </div>
      )}

      {(() => {
        // Build tree sorted alphabetically at each level
        const buildSortedTree = (cats, parentId = null) =>
          cats
            .filter(c => (c.parent_id || null) === parentId)
            .sort((a, b) => a.name.localeCompare(b.name, 'cs'))
            .flatMap(c => [c, ...buildSortedTree(cats, c.id)]);

        const sorted = buildSortedTree(categories);

        const getLevel = (c, cats, level = 0) => {
          if (!c.parent_id) return level;
          const parent = cats.find(x => x.id === c.parent_id);
          return parent ? getLevel(parent, cats, level + 1) : level;
        };

        return (
          <div style={{ display: 'grid', gap: 4 }}>
            {sorted.map(c => {
              const level = getLevel(c, categories);
              return (
                <div key={c.id} style={{
                  background: level === 0 ? '#fff' : level === 1 ? '#fafafa' : '#f5f5f5',
                  borderRadius: 8,
                  padding: '10px 14px',
                  border: '1px solid #f3f4f6',
                  borderLeft: `3px solid ${level === 0 ? '#0e76bc' : level === 1 ? '#e07b6a' : '#e5e7eb'}`,
                  marginLeft: level * 20,
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    {level > 0 && <span style={{ color: '#9ca3af', fontSize: 12 }}>{'└─'.repeat(level)}</span>}
                    <span style={{ fontWeight: level === 0 ? 700 : 600, fontSize: level === 0 ? 14 : 13, color: '#111827' }}>{c.name}</span>
                    {level === 0 && (
                      <span style={{ fontSize: 11, color: '#9ca3af', fontWeight: 400 }}>
                        ({categories.filter(x => x.parent_id === c.id).length} podkat.)
                      </span>
                    )}
                  </div>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <BtnSecondary onClick={() => handleEdit(c)}>Upravit</BtnSecondary>
                    <BtnDanger onClick={() => handleDelete(c.id)}>Smazat</BtnDanger>
                  </div>
                </div>
              );
            })}
          </div>
        );
      })()}
    </div>
  );
}

// ─── SUBDISTRIBUTORS TAB ─────────────────────────────────────────────────────

function SubdistributorsTab({ apiFetch }) {
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const empty = { name: '', country: 'CZ', sort_order: 0 };
  const [form, setForm] = useState(empty);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const load = () => apiFetch('/admin/subdistributors').then(setItems);
  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    try {
      if (editing) await apiFetch(`/admin/subdistributors/${editing}`, { method: 'PUT', body: JSON.stringify({ ...form, is_active: 1 }) });
      else await apiFetch('/admin/subdistributors', { method: 'POST', body: JSON.stringify(form) });
      setShowForm(false); setEditing(null); setForm(empty); load();
    } catch (e) { alert(e.message); }
  };

  const handleEdit = (item) => {
    setForm({ name: item.name, country: item.country||'CZ', sort_order: item.sort_order||0 });
    setEditing(item.id); setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (id === 1) { alert('Hlavniho distributora nelze smazat.'); return; }
    if (!window.confirm('Opravdu smazat?')) return;
    await apiFetch(`/admin/subdistributors/${id}`, { method: 'DELETE' }); load();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <span style={{ fontWeight: 700, fontSize: 15, color: '#374151' }}>{items.filter(i => i.is_active).length} distributoru</span>
        <BtnPrimary onClick={() => { setForm(empty); setEditing(null); setShowForm(!showForm); }}>
          {showForm && !editing ? 'Zavrit' : '+ Pridat subdistributora'}
        </BtnPrimary>
      </div>

      {showForm && (
        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 10, padding: 20, marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 15, fontWeight: 700 }}>{editing ? 'Upravit' : 'Novy subdistributor'}</h3>
          <Grid2>
            <Inp label="Nazev firmy" value={form.name} onChange={v => set('name', v)} required />
            <Sel label="Zeme" value={form.country} onChange={v => set('country', v)} options={[
              { value: 'CZ', label: 'Ceska republika' },
              { value: 'SK', label: 'Slovensko' },
              { value: 'RO', label: 'Rumunsko' },
            ]} />
          </Grid2>
          <div style={{ display: 'flex', gap: 10 }}>
            <BtnPrimary onClick={handleSave} disabled={!form.name}>Ulozit</BtnPrimary>
            <BtnSecondary onClick={() => { setShowForm(false); setEditing(null); }}>Zrusit</BtnSecondary>
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gap: 10 }}>
        {items.map(item => (
          <div key={item.id} style={{ background: '#fff', borderRadius: 10, padding: '14px 18px', border: `1px solid ${item.id === 1 ? '#b3d9f2' : '#f3f4f6'}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, opacity: item.is_active ? 1 : 0.5 }}>
            <div>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#111827', display: 'flex', alignItems: 'center', gap: 8 }}>
                {item.name}
                {item.id === 1 && <span style={{ background: '#e8f4fc', color: '#0e76bc', fontSize: 10, fontWeight: 700, padding: '1px 7px', borderRadius: 10 }}>HLAVNÍ</span>}
              </div>
              <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}>{item.country}</div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <BtnSecondary onClick={() => handleEdit(item)}>Upravit</BtnSecondary>
              {item.id !== 1 && <BtnDanger onClick={() => handleDelete(item.id)}>Smazat</BtnDanger>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── PRODUCTS TAB ────────────────────────────────────────────────────────────

function ProductsTab({ apiFetch }) {
  const [products, setProducts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const empty = { name: '', sku: '', category: '', sort_order: 0 };
  const [form, setForm] = useState(empty);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const load = () => apiFetch('/admin/products').then(setProducts);
  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    try {
      if (editing) await apiFetch(`/admin/products/${editing}`, { method: 'PUT', body: JSON.stringify({ ...form, is_active: 1 }) });
      else await apiFetch('/admin/products', { method: 'POST', body: JSON.stringify(form) });
      setShowForm(false); setEditing(null); setForm(empty); load();
    } catch (e) { alert(e.message); }
  };

  const handleEdit = (p) => {
    setForm({ name: p.name, sku: p.sku||'', category: p.category||'', sort_order: p.sort_order||0 });
    setEditing(p.id); setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Opravdu smazat produkt?')) return;
    await apiFetch(`/admin/products/${id}`, { method: 'DELETE' }); load();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <span style={{ fontWeight: 700, fontSize: 15, color: '#374151' }}>{products.filter(p => p.is_active).length} aktivnich produktu</span>
        <BtnPrimary onClick={() => { setForm(empty); setEditing(null); setShowForm(!showForm); }}>
          {showForm && !editing ? 'Zavrit' : '+ Pridat produkt'}
        </BtnPrimary>
      </div>

      {showForm && (
        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 10, padding: 20, marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 15, fontWeight: 700 }}>{editing ? 'Upravit produkt' : 'Novy produkt'}</h3>
          <Grid2>
            <Inp label="Nazev produktu" value={form.name} onChange={v => set('name', v)} required />
            <Inp label="SKU / Model" value={form.sku} onChange={v => set('sku', v)} />
            <Inp label="Kategorie" value={form.category} onChange={v => set('category', v)} />
            <Inp label="Poradi (nizsi = drive)" value={form.sort_order} onChange={v => set('sort_order', Number(v))} type="number" />
          </Grid2>
          <div style={{ display: 'flex', gap: 10 }}>
            <BtnPrimary onClick={handleSave} disabled={!form.name}>Ulozit</BtnPrimary>
            <BtnSecondary onClick={() => { setShowForm(false); setEditing(null); }}>Zrusit</BtnSecondary>
          </div>
        </div>
      )}

      <div style={{ border: '1px solid #f3f4f6', borderRadius: 10, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#f9fafb', borderBottom: '2px solid #e5e7eb' }}>
              {['Nazev', 'SKU', 'Kategorie', 'Stav', 'Akce'].map(h => (
                <th key={h} style={{ padding: '10px 12px', textAlign: 'left', color: '#6b7280', fontWeight: 600, fontSize: 12 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {products.map(p => (
              <tr key={p.id} style={{ borderBottom: '1px solid #f3f4f6', opacity: p.is_active ? 1 : 0.4 }}>
                <td style={{ padding: '10px 12px', fontWeight: 600, color: '#111827' }}>{p.name}</td>
                <td style={{ padding: '10px 12px', color: '#6b7280', fontFamily: 'monospace' }}>{p.sku}</td>
                <td style={{ padding: '10px 12px', color: '#374151' }}>{p.category}</td>
                <td style={{ padding: '10px 12px' }}>
                  <span style={{ background: p.is_active ? '#f0fdf4' : '#f9fafb', color: p.is_active ? '#166534' : '#9ca3af', fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 6 }}>
                    {p.is_active ? 'Aktivni' : 'Skryty'}
                  </span>
                </td>
                <td style={{ padding: '10px 12px' }}>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <BtnSecondary onClick={() => handleEdit(p)}>Upravit</BtnSecondary>
                    <BtnDanger onClick={() => handleDelete(p.id)}>Smazat</BtnDanger>
                  </div>
                </td>
              </tr>
            ))}
            {products.length === 0 && (
              <tr><td colSpan={5} style={{ padding: 30, textAlign: 'center', color: '#9ca3af' }}>Zadne produkty. Pridejte prvni produkt.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ─── CONTACT TAB ─────────────────────────────────────────────────────────────

function ContactTab({ apiFetch }) {
  const [contacts, setContacts] = useState([]);
  const [distributor, setDistributor] = useState({ company_name: '', address: '', phone: '', email: '', description_cs: '', description_sk: '', description_ro: '' });
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const emptyContact = { name: '', role_cs: '', role_sk: '', role_ro: '', role_en: '', role_hu: '', email: '', phone: '', department: 'other', sort_order: 0 };
  const [form, setForm] = useState(emptyContact);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const setDist = (k, v) => setDistributor(d => ({ ...d, [k]: v }));

  const load = () => apiFetch('/contacts').then(data => {
    if (data && data.contacts !== undefined) {
      setContacts(data.contacts);
      if (data.distributor) setDistributor(data.distributor);
    }
  });
  useEffect(() => { load(); }, []);

  const handleSaveDistributor = async () => {
    try {
      await apiFetch('/distributor-info', { method: 'PUT', body: JSON.stringify(distributor) });
      alert('Ulozeno!');
    } catch (e) { alert(e.message); }
  };

  const handleSaveContact = async () => {
    try {
      if (editing) await apiFetch(`/contacts/${editing}`, { method: 'PUT', body: JSON.stringify(form) });
      else await apiFetch('/contacts', { method: 'POST', body: JSON.stringify(form) });
      setShowForm(false); setEditing(null); setForm(emptyContact); load();
    } catch (e) { alert(e.message); }
  };

  const handleEdit = (c) => {
    setForm({ name: c.name||'', role_cs: c.role_cs||'', role_sk: c.role_sk||'', role_ro: c.role_ro||'', email: c.email||'', phone: c.phone||'', department: c.department||'other', sort_order: c.sort_order||0 });
    setEditing(c.id); setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Opravdu smazat?')) return;
    await apiFetch(`/contacts/${id}`, { method: 'DELETE' }); load();
  };

  return (
    <div>
      {/* Distributor info */}
      <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 10, padding: 20, marginBottom: 24 }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 15, fontWeight: 700 }}>Informace o distributorovi</h3>
        <Grid2>
          <Inp label="Nazev firmy" value={distributor.company_name||''} onChange={v => setDist('company_name', v)} />
          <Inp label="Adresa" value={distributor.address||''} onChange={v => setDist('address', v)} />
          <Inp label="Telefon" value={distributor.phone||''} onChange={v => setDist('phone', v)} />
          <Inp label="E-mail" value={distributor.email||''} onChange={v => setDist('email', v)} />
        </Grid2>
        <Grid3>
          <Inp label="Popis (CS)" value={distributor.description_cs||''} onChange={v => setDist('description_cs', v)} type="textarea" />
          <Inp label="Popis (SK)" value={distributor.description_sk||''} onChange={v => setDist('description_sk', v)} type="textarea" />
          <Inp label="Popis (RO)" value={distributor.description_ro||''} onChange={v => setDist('description_ro', v)} type="textarea" />
        </Grid3>
        <BtnPrimary onClick={handleSaveDistributor}>Ulozit informace</BtnPrimary>
      </div>

      {/* Contacts */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <span style={{ fontWeight: 700, fontSize: 15, color: '#374151' }}>{contacts.length} kontaktu</span>
        <BtnPrimary onClick={() => { setForm(emptyContact); setEditing(null); setShowForm(!showForm); }}>
          {showForm ? 'Zavrit' : '+ Pridat kontakt'}
        </BtnPrimary>
      </div>

      {showForm && (
        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 10, padding: 20, marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 15, fontWeight: 700 }}>{editing ? 'Upravit kontakt' : 'Novy kontakt'}</h3>
          <Grid2>
            <Inp label="Jmeno" value={form.name} onChange={v => set('name', v)} required />
            <Sel label="Oddeleni" value={form.department} onChange={v => set('department', v)} options={[
              { value: 'other', label: 'Ostatni' }, { value: 'sales', label: 'Obchod' },
              { value: 'technical', label: 'Technicka podpora' }, { value: 'projects', label: 'Projekty' },
            ]} />
            <Inp label="Role (CS)" value={form.role_cs} onChange={v => set('role_cs', v)} />
            <Inp label="Role (SK)" value={form.role_sk} onChange={v => set('role_sk', v)} />
            <Inp label="Role (RO)" value={form.role_ro||''} onChange={v => set('role_ro', v)} />
            <Inp label="Role (EN)" value={form.role_en||''} onChange={v => set('role_en', v)} />
            <Inp label="Role (HU)" value={form.role_hu||''} onChange={v => set('role_hu', v)} />
            <Inp label="E-mail" value={form.email} onChange={v => set('email', v)} type="email" />
            <Inp label="Telefon" value={form.phone} onChange={v => set('phone', v)} />
          </Grid2>
          <div style={{ display: 'flex', gap: 10 }}>
            <BtnPrimary onClick={handleSaveContact} disabled={!form.name}>Ulozit</BtnPrimary>
            <BtnSecondary onClick={() => { setShowForm(false); setEditing(null); }}>Zrusit</BtnSecondary>
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gap: 10 }}>
        {contacts.map(c => (
          <div key={c.id} style={{ background: '#fff', borderRadius: 10, padding: '14px 18px', border: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#111827' }}>{c.name}</div>
              <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}>
                {c.role_cs} · {c.department} · {c.email} · {c.phone}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <BtnSecondary onClick={() => handleEdit(c)}>Upravit</BtnSecondary>
              <BtnDanger onClick={() => handleDelete(c.id)}>Smazat</BtnDanger>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function AdminPage() {
  const { t, apiFetch } = useAuth();
  const [tab, setTab] = useState('news');
  const TABS = [
    { key: 'news',        label: 'Novinky' },
    { key: 'trainings',   label: 'Skoleni' },
    { key: 'exhibitions', label: 'Vystavy' },
    { key: 'users',       label: 'Uzivatele' },
    { key: 'pages',        label: 'Stránky' },
    { key: 'favorites',    label: '👍 Oblíbené' },
    { key: 'translations', label: 'Překlady' },
    { key: 'catalog',     label: 'Kat. produktů' },
    { key: 'subdist',     label: 'Subdistributoři' },
    { key: 'contact',     label: 'Kontakt' },
  ];
  return (
    <div>
      <h1 style={{ margin: '0 0 20px', fontSize: 26, fontWeight: 800, color: '#111827' }}>Administrace</h1>
      <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 1px 6px rgba(0,0,0,0.06)', border: '1px solid #f3f4f6', overflow: 'hidden' }}>
        <div style={{ borderBottom: '1px solid #f3f4f6', padding: '0 16px', display: 'flex', overflowX: 'auto' }}>
          {TABS.map(tb => <TabBtn key={tb.key} label={tb.label} active={tab === tb.key} onClick={() => setTab(tb.key)} />)}
        </div>
        <div style={{ padding: '24px' }}>
          {tab === 'news'        && <NewsTab apiFetch={apiFetch} />}
          {tab === 'trainings'   && <TrainingsTab apiFetch={apiFetch} />}
          {tab === 'exhibitions' && <ExhibitionsTab apiFetch={apiFetch} />}
          {tab === 'users'       && <UsersTab apiFetch={apiFetch} />}
          {tab === 'pages'        && <PagesTab apiFetch={apiFetch} />}
          {tab === 'favorites'    && <FavoritesTab apiFetch={apiFetch} />}
          {tab === 'translations' && <TranslationsTab apiFetch={apiFetch} />}
          {tab === 'catalog'     && <CatalogCategoriesTab apiFetch={apiFetch} />}
          {tab === 'subdist'     && <SubdistributorsTab apiFetch={apiFetch} />}
          {tab === 'contact'     && <ContactTab apiFetch={apiFetch} />}
        </div>
      </div>
    </div>
  );
}
